import { type FileType } from "~/api/types";
import {
  WordFileIcon,
  PowerPointFileIcon,
  ExcelFileIcon,
  WordProductIcon,
  ExcelProductIcon,
  PowerPointProductIcon,
} from "~/icons/Office";
import { FileText } from "lucide-react";
import PDFIcon from "~/icons/PDFIcon";

interface Props {
  type: FileType | null;
  className?: string;
  variant?: "file" | "product";
}

const DocumentIcon = ({ type, className, variant = "file" }: Props) => {
  if (type === "docx") {
    return variant === "file" ? (
      <WordFileIcon className={className} />
    ) : (
      <WordProductIcon className={className} />
    );
  }
  if (type === "xlsx") {
    return variant === "file" ? (
      <ExcelFileIcon className={className} />
    ) : (
      <ExcelProductIcon className={className} />
    );
  }
  if (type === "pptx") {
    return variant === "file" ? (
      <PowerPointFileIcon className={className} />
    ) : (
      <PowerPointProductIcon className={className} />
    );
  }
  if (type === "pdf") {
    return <PDFIcon className={className} />;
  }

  return <FileText strokeWidth={1.3} className={className} />;
};

export default DocumentIcon;
